import React from 'react';
import { Typography, Box, Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Business } from '@mui/icons-material';

const HeaderContainer = styled(Box)(({ theme }) => ({
  padding: '40px',
  background: '#0b91d6',
  borderRadius: '20px',
  boxShadow: '0 10px 40px rgba(11, 145, 214, 0.3)',
  color: 'white',
  marginBottom: '40px',
  position: 'relative',
  overflow: 'hidden',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: '-50%',
    right: '-10%',
    width: '300px',
    height: '300px',
    background: 'rgba(255,255,255,0.1)',
    borderRadius: '50%'
  },
  [theme.breakpoints.down('md')]: {
    padding: '32px'
  },
  [theme.breakpoints.down('sm')]: {
    padding: '24px'
  }
}));

const HeaderContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  gap: '20px',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column'
  }
}));

const HeaderTextContent = styled(Box)(({ theme }) => ({
  flex: 1
}));

const HeaderTitle = styled(Typography)(({ theme }) => ({
  fontFamily: 'Inter, sans-serif',
  fontSize: '36px',
  fontWeight: 700,
  letterSpacing: '-0.5px',
  marginBottom: '12px',
  display: 'flex',
  alignItems: 'center',
  gap: '16px',
  position: 'relative',
  zIndex: 1,
  [theme.breakpoints.down('md')]: {
    fontSize: '28px'
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '24px'
  }
}));

const HeaderSubtitle = styled(Typography)(({ theme }) => ({
  fontFamily: 'Inter, sans-serif',
  fontSize: '16px',
  fontWeight: 400,
  opacity: 0.95,
  position: 'relative',
  zIndex: 1,
  [theme.breakpoints.down('sm')]: {
    fontSize: '14px'
  }
}));

const PageHeader = ({ title, subtitle, action }) => {
  return (
    <HeaderContainer>
      <HeaderContent>
        <HeaderTextContent>
      <HeaderTitle>
        <Business sx={{ fontSize: 40 }} />
        {title}
      </HeaderTitle>
      <HeaderSubtitle>{subtitle}</HeaderSubtitle>
        </HeaderTextContent>
        {action && (
          <Box sx={{ position: 'relative', zIndex: 1 }}>
            {action}
          </Box>
        )}
      </HeaderContent>
    </HeaderContainer>
  );
};

export default PageHeader;